var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00006 2.49997C6.00006 1.83822 6.73332 1.56174 7.00006 1.43804C6.64697 3.95342 7.06592 7.33277 8.50006 9.49997C9.9342 11.6672 12.5468 13.3417 15.0001 14C14.7819 14.1971 15.5001 13.5 14.0001 15C10.7603 17.1439 5.14398 16.2398 3.00006 13C0.856144 9.76019 1.76028 4.64389 5.00006 2.49997ZM4.55848 1.43804C0.503246 4.12158 -0.610017 9.59074 2.07353 13.646C4.75707 17.7012 10.2262 18.8145 14.2815 16.1309C15.6185 15.2461 16.6317 14.0475 17.2984 12.7084C14.2608 12.8911 11.2187 11.5027 9.41997 8.78449C7.62122 6.0663 7.53246 2.72359 8.88801 -0.000933806C7.3433 0.0890919 5.84976 0.585488 4.55848 1.43804Z",
    fill: "#FCAC19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.80fc937dc39acd32e5d635884b1a256a.svg";
export { ForwardRef as ReactComponent };